import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import MailTagComponent from '../MailTagComponent.vue'

export const MailTag = Node.create({
  name: 'mailTag',
  
  group: 'inline',
  
  inline: true,
  
  atom: true,
  
  selectable: false,
  
  draggable: false,
  
  addAttributes() {
    return {
      mail: {
        default: ''
      },
      type: {
        default: 'user'
      },
      valid: {
        default: true,
        parseHTML: value => value === 'true'
      }
    }
  },
  
  parseHTML() {
    return [
      {
        tag: 'mail',
      },
    ]
  },
  
  renderHTML({ HTMLAttributes }) {
    return ['mail', mergeAttributes(HTMLAttributes), 0]
  },
  
  addNodeView() {
    return VueNodeViewRenderer(MailTagComponent)
  },
}) 